import React from 'react'
import './login.css'
import { Link, Redirect } from 'react-router-dom';
import Api from '../../services/api'
import Allestec from '../../assets/allestec.png'
import { LinkStyle } from '../../Components/localStyles/localStyles'
import Select from '../../Components/select/select'
import DropDown from '../../Components/dropDown/dropDown'

export default class register extends React.Component {
    state = { password: "", ConfirmPass: "", email: "", username: "", redirect: false,levels:
    [{value:'Insp./Prep./Ferram.', label: 'Insp./Prep./Ferram.'},{value:'Supervisor', label: 'Supervisor'},{value:'Coordenador', label: 'Coordenador'},{value:'Gerente', label: 'Gerente'},{value:'Diretor', label:'Diretor'}],level:null}

    changeValueName = (value) => { this.setState({ username: value.target.value }) }
    changeValuePassword = (val) => { this.setState({ password: val.target.value }) }
    changeValueConfirm = (value) => { this.setState({ ConfirmPass: value.target.value }) }
    changeValueEmail = (val) => { this.setState({ email: val.target.value }) }
    changeValueLevel = (val) => { this.setState({ level: val.value }) }

    validation = () => {
        const { password, ConfirmPass, email, username,level } = this.state;
        if ((username !== null && username !== "") && (password !== null && password !== "") && (ConfirmPass !== null && ConfirmPass !== "") && (email !== null && email !== "")) {
            if (password.trim() === ConfirmPass.trim()) {
                Api.post('/register/', { username: username, password: password, email: email,
                level:level, is_admin: 0, is_validated: 1, id_employee: null}
                ).then((response) => {
                    if (response.status === 201) {
                        alert('Usuário cadastrado com sucesso!');
                        this.setState({ redirect: true })
                    } else {
                        alert('Já existe um usuário cadastrado com alguma dessas informações!')
                    }
                }
                ).catch((err) => {
                    alert(err)
                })
            } else {
                alert('Senhas não conferem.')
            }
        } else {
            alert('Necessário preencher todos os campos.')
        }
    }

    render() {
        if (this.state.redirect)
            return <Redirect to="/"></Redirect>

        return (
            <div  className="login">
                <section className ="login-form" >
                    <form className="form-sec-login" action="" autocomplete="off">
                        <div className="title-login"><img src={Allestec} ></img></div>
                        <div className="input-block">
                            <input value={this.state.username}  placeholder="Nome de usuário" maxLength={20} onChange={this.changeValueName} type="text" autoFocus required />
                        </div>
                        <div className="input-block">
                            <input value={this.state.email} placeholder="E-mail" maxLength={45} onChange={this.changeValueEmail} type="email" id="login-email" required />
                        </div>
                        <div className="input-block">
                            <input value={this.state.password} placeholder="Senha" maxLength={60} onChange={this.changeValuePassword} type="password" id="login-password" required />
                        </div>
                        <div className="input-block">
                            <input value={this.state.ConfirmPass} placeholder="Confirmar senha" maxLength={60} onChange={this.changeValueConfirm} type="password" id="login-password" required />
                        </div>
                        <div className="input-block"> 
                        <Select autoSelect={true} label="Nível de Acesso" handleSelect={this.changeValueLevel} arrData={this.state.levels} />
                        
                        {/*<DropDown title="Nível de acesso" parentCallback={this.changeValueLevel}
                        arrayItens={this.state.levels} />*/}</div>
                        <div className="spaceButton">
                            <button onClick={this.validation} type="submit" className="btn-login">Enviar</button>
                            
                        </div>
                        <Link style={LinkStyle}  to="/">
                                <button type="submit" className="btn-login" >Voltar </button>
                            </Link>
                    </form>
                </section>
            </div>
        )
    }
}